import { Mutation, UserMfaPreference } from 'graphql/generated/graphqlTypes';

export function setMfaPreferenceDataForMutation(
  setMfaPreference: UserMfaPreference
): Pick<Mutation, 'setMfaPreference'> {
  return {
    setMfaPreference
  };
}

export const mockedSetMfaPreferenceDataForQuery = setMfaPreferenceDataForMutation({
  emailMfaEnabled: false,
  __typename: 'UserMfaPreference'
});
